import React from 'react';
import PropTypes from 'prop-types';
import ConfirmationSection from './ConfirmationSection';

const ConfirmationTrainingPayWaiver = ({ formData }) => {
  const waiving = formData?.servicePay?.isWaivingVaBenefitsForTrainingPay;
  if (typeof waiving !== 'boolean') return null;

  return (
    <ConfirmationSection
      title="Training pay waiver"
      rows={[
        {
          label: 'Do you want to receive VA disability compensation?',
          value: waiving
            ? 'No, I don’t want VA disability compensation for those days.'
            : 'Yes, I want to receive VA disability compensation for those days.',
        },
      ]}
    />
  );
};

ConfirmationTrainingPayWaiver.propTypes = {
  formData: PropTypes.shape({
    servicePay: PropTypes.shape({
      isWaivingVaBenefitsForTrainingPay: PropTypes.bool,
    }),
  }),
};

export default ConfirmationTrainingPayWaiver;
